import Vue from 'vue';
import axios from 'axios'
import _ from 'lodash'
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// @ts-expect-error 型チェック不要部分
import VueFlags from '@growthbunker/vueflags';
// @ts-expect-error 型チェック不要部分
import { ClientOnly } from 'vue-client-only';

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import App from './App.vue';
import store from './store';
import createRouter from './router';

import SuccessModal from './components/parts/modal/Success.vue'
import ConfirmModal from './components/parts/modal/Confirm.vue'

import 'vue-loading-overlay/dist/vue-loading.css';

// 共通css
import '@/assets/css/index.css';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

const Loading = require('vue-loading-overlay');

Vue.config.productionTip = false;

const router = createRouter();

// axios configuration
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
axios.interceptors.request.use((request) => _.set(request, 'headers.Authorization', `Bearer ${store.state.auth.token}`));
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response.status === 401) {
      await store.dispatch('logout')
      if (router.currentRoute.name !== 'Login') {
        return router.push({ name: 'Login', query: { redirect: router.currentRoute.fullPath } })
      }
    }
    return Promise.reject(error);
  },
);

Vue.use(VueFlags, { iconPath: 'flags' });

library.add(far, fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('client-only', ClientOnly);

Vue.component('SuccessModal', SuccessModal)
Vue.component('ConfirmModal', ConfirmModal)

Vue.component('Loading', Loading);

/* eslint-disable no-new */
new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount('#app');
